import * as angular from 'angular';
import security from '../../service/security/security-services';
import {AUTH_EVENTS} from '../../service/security/security-module';
import contractService from '../../service/contract/contract-services';

type VisibleIcons = {
  home: boolean;
  files: boolean;
  features: boolean;
  locationals: boolean;
  locationals2: boolean;
  associations: boolean;
  export: boolean;
  download: boolean;
  status: boolean;
  settings: boolean;
  events: boolean;
};

const baseVisibleIcons: VisibleIcons = {
    home: true,
    files: true,
    features: true,
    locationals: false,
    locationals2: false,
    associations: false,
    export: false,
    download: true,
    status: true,
    settings: false,
    events: true
};

function saveVisibleIcons(visible: VisibleIcons) {
    localStorage.setItem('visibleIcons', JSON.stringify(visible));
}

function getVisibleIconsFromStorage() {
    const possibleItem = localStorage.getItem('visibleIcons');
    if (possibleItem) {
        return JSON.parse(possibleItem) as VisibleIcons;
    }
    return baseVisibleIcons;
}

export default function sideMenuController(
        $q: angular.IQService, $scope: angular.IScope, security: security, $routeParams: angular.route.IRouteParamsService,
        $route: angular.route.IRouteService, contract: contractService) {
    const vm = this;

    vm.activeTab = ($route.current as any).activeTab;
    vm.contract = contract;
    vm.contractId = $routeParams.contractId;

    vm.visibleIcons = getVisibleIconsFromStorage();

    // Ingenting vises før permissions er på plass.

    vm.getDisabledTitleText = getDisabledTitleText;
    vm.isNvdbContentReady = isNvdbContentReady;
    vm.isContentReady = isContentReady;
    vm.isNvdbContentReadyAndOpen = isNvdbContentReadyAndOpen;
    vm.isContentReadyAndOpen = isContentReadyAndOpen;
    vm.projectHasFeatures = projectHasFeatures;

    $scope.$on(AUTH_EVENTS.AUTH_CHANGED, init);

    init();

    function init() {
        $q.all([security.ensureCurrentUser(), contract.selectContract($routeParams.contractId)])
            .then(function([user]) {
                const useOldLocational = user.featureToggles.some(toggle => toggle === 'locational');

                vm.currentUser = user;
                const locationalPermission = user.hasPermission('UI_LOCATIONAL_PANE:VIEW', $routeParams.contractId);
                const icons: VisibleIcons = {
                    home: user.hasPermission('UI_HOME_PANE:VIEW', $routeParams.contractId),
                    files: user.hasPermission('UI_FILE_PANE:VIEW', $routeParams.contractId),
                    features: user.hasPermission('UI_FEATURE_PANE:VIEW', $routeParams.contractId),
                    locationals: useOldLocational && locationalPermission,
                    locationals2: !useOldLocational && locationalPermission,
                    associations: user.hasPermission('UI_ASSOCIATION_PANE:VIEW', $routeParams.contractId),
                    export: user.hasPermission('UI_EXPORT_PANE:VIEW', $routeParams.contractId),
                    download: user.hasPermission('UI_DOWNLOAD_PANE:VIEW', $routeParams.contractId),
                    status: user.hasPermission('UI_STATUS_PANE:VIEW', $routeParams.contractId),
                    settings: user.hasPermission('UI_SETTINGS_PANE:VIEW', $routeParams.contractId),
                    events: user.hasPermission('UI_EVENTLOG_PANE:VIEW', $routeParams.contractId)
                };
                saveVisibleIcons(icons);
                vm.visibleIcons = icons;
            });
    }

    function projectHasFeatures() {
       return vm.contract.hasAnyFeatures;
    }

    function isNvdbContentReady() {
        return !vm.contract.uploadingFiles;
    }

    function isContentReady() {
        return !vm.contract.uploadingFiles;
    }

    function isNvdbContentReadyAndOpen() {
        return vm.isNvdbContentReady() && vm.contract.archivedState === 'OPEN';
    }

    function isContentReadyAndOpen() {
        return vm.isContentReady() && vm.contract.archivedState === 'OPEN';
    }

    function getDisabledTitleText() {
        if (!vm.contract.hasNvdbFeatures) {
            return 'Kontrakten har ingen vegobjekter';
        }
        if (vm.contract.uploadingFiles) {
            return 'Opplasting og validering av nye vegobjekter pågår';
        }
        if (vm.contract.archivedState === 'ARCHIVED') {
            return 'Kontrakt er arkivert';
        }
        return '';
    }
}
sideMenuController.$inject = ['$q', '$scope', 'security', '$routeParams', '$route', 'contract'];
